<template>
  <input
    type="checkbox"
    :class="`cheetah-toggle-button cheetah-toggle-button__${color || 'information'}`"
    :checked="checked"
    @change="$emit('change', $event.target.checked)"
  />
</template>

<script>
export default {
  name: 'ToggleButtonComponent',
  props: ['color', 'checked']
}
</script>

<style lang="scss">
.cheetah-toggle-button {
  position: relative;
	width: 38px;
	height: 13px;
  appearance: none;
	outline: none;
  border-radius: 45px;

	transition: .5s;


  &::before {
    content: '';
		position: absolute;
		width: 18px;
		height: 18px;
		border-radius: 50px;
		top: -2px;
		left: 0;
		background: #FFFFFF;
		transform: scale(1.1);
    box-shadow: 0px 1px 1px #0000003D;
    transition: .5s;

    cursor: pointer;
  }

  &:checked::before {
    left: 20px;
  }


  &__information {
    background: #C7C7C7;

      &:checked {
        background: #0080FC;
      }

      &::before {
        background: #FFFFFF;
      }
  }

  &__success {
    background: #C7C7C7;

    &:checked {
      background: #9DE8D4;
    }

    &:checked::before {
      background:  #31C38E;

      left: 20px;
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/commons/ToggleButtonComponent.vue